import { render, staticRenderFns } from "./card-gatorz-custom.vue?vue&type=template&id=f9b9db96&scoped=true&"
import script from "./card-gatorz-custom.vue?vue&type=script&lang=js&"
export * from "./card-gatorz-custom.vue?vue&type=script&lang=js&"
import style0 from "./card-gatorz-custom.vue?vue&type=style&index=0&id=f9b9db96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b9db96",
  null
  
)

export default component.exports